import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { formatDistanceInMiles } from "@src/appV2/lib/utils/distance";
import { Card, Text } from "@src/appV2/redesign/system/ui-components";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { PlacementLocationMap } from "../../PlacementLocationMap";
import { PlacementSectionTemplate } from "./PlacementSectionTemplate";

interface WorkplaceLocationSectionProps {
  placement: PlacementWithDetails;
  placementCandidateId: string;
}

export function WorkplaceLocationSection(props: WorkplaceLocationSectionProps) {
  const { placement, placementCandidateId } = props;

  function getDistanceLabel(distance: number) {
    const distanceInMiles = formatDistanceInMiles(distance, "long");
    return `This workplace is ${distanceInMiles} from your home address.`;
  }

  return (
    <Stack spacing={5}>
      <PlacementSectionTemplate title="Workplace location" iconType="car">
        {isDefined(placement.distance) && (
          <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {getDistanceLabel(placement.distance)}
          </Text>
        )}
      </PlacementSectionTemplate>
      <Card>
        <PlacementLocationMap
          coordinates={placement.coordinates}
          formattedAddress={placement.address.formatted ?? ""}
          placementId={placement.id}
          placementCandidateId={placementCandidateId}
        />
      </Card>
    </Stack>
  );
}
